import Session from "@/models/Session";
import moment from "moment";
import * as sessiondate_helper from "@/helpers/sessiondate_helper"

export function SessionInfilter(session: Session, search: string, eventtype: string, filters: {
  GroepsGrootte: number;
  VlsCode: string;
  InterestAreas: string[];
  Audiences: string[];
  Buildings: string[];
  SessionDates: number[];
  StudyLanguages: string[];
  StudyTypes: string[];
  StudyForms: string[];
  Subjects: string[];
}): boolean {
  let interestAreaFilter = filters.InterestAreas.length === 0;
  let buildingFilter = filters.Buildings.length === 0;
  let dateFilter = filters.SessionDates.length === 0;
  let languageFilter = filters.StudyLanguages.length === 0;
  let studyTypeFilter = filters.StudyTypes.length === 0;
  let studyFormFilter = filters.StudyForms.length === 0;
  let subjectsFilter = filters.Subjects.length === 0;
  let audienceFilter = filters.Audiences.length === 0;
  let groepFilter = session.maxCapacity < 2 || filters.GroepsGrootte <= (session.maxCapacity - session.registrationCount);
  let closingDateFilter = !session.sluitdatumtijd;

  if (session.sluitdatumtijd) {
    const sluitdatumtijd = new Date(session.sluitdatumtijd);
    closingDateFilter = moment().isBefore(moment(sluitdatumtijd));
  }

  const searchFilter =
    search == null ||
    search == "" ||
    session.name
      .toLowerCase()
      .indexOf(search.toLowerCase()) >= 0 ||
    (session.parentSession != null && session.parentSession.name
      .toLowerCase()
      .indexOf(search.toLowerCase()) >= 0);

  // [1] Check the interest filter
  if (filters.InterestAreas.length > 0) {
    if (session.interestAreas && session.interestAreas.length > 0) {
      interestAreaFilter = false;
      session.interestAreas.forEach(element => {
        if (!interestAreaFilter) {
          interestAreaFilter = filters.InterestAreas.includes(
            element.id
          );
        }
      });
    }
  }

  if (filters.Buildings.length > 0) {
    if (session.building) {
      buildingFilter = filters.Buildings.includes(
        session.building.id
      );
    }
  }

  if (filters.Audiences.length > 0) {
    if (session.audience) {
      audienceFilter = filters.Audiences.includes(
        session.audience.id
      );
    }
  }

  if (filters.StudyTypes.length > 0) {
    if (session.studytype) {
      studyTypeFilter = filters.StudyTypes.includes(
        session.studytype.id
      );
    }
  }

  if (filters.StudyForms.length > 0) {
    if (session.studyform) {
      studyFormFilter = filters.StudyForms.includes(
        session.studyform.id
      );
    }
  }

  if (filters.SessionDates.length > 0) {
    if (session.start) {
      const sessionStartDate = new Date(session.start);
      let dateId = sessiondate_helper.CalcDateID(sessionStartDate, eventtype);

      if (session.withoutDate) dateId = 100000000;
      dateFilter = filters.SessionDates.includes(dateId);
    }
  }

  if (filters.StudyLanguages.length > 0) {
    if (session.parentSession) {
      let dutch = false;
      let english = false;
      let german = false;

      if (filters.StudyLanguages.includes("NL"))
        dutch = session.parentSession.nederlands == "true";

      if (filters.StudyLanguages.includes("EN"))
        english = session.parentSession.engels == "true";

      if (filters.StudyLanguages.includes("DE"))
        german = session.parentSession.duits == "true";

      languageFilter = dutch || english || german;
    }
  }

  if (filters.Subjects.length > 0) {
    if (session.subject) {
      subjectsFilter = filters.Subjects.includes(
        session.subject.id
      );
    }
  }

  return (
    interestAreaFilter &&
    buildingFilter &&
    dateFilter &&
    searchFilter &&
    languageFilter &&
    studyTypeFilter &&
    studyFormFilter &&
    audienceFilter &&
    groepFilter &&
    subjectsFilter &&
    closingDateFilter);
}
